import { render } from "./Agenda.vue?vue&type=template&id=790f6248&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=790f6248&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-790f6248"

export default script